
import img1 from '../images/layouts/team-01.png'
import img2 from '../images/layouts/team-02.png'
import img3 from '../images/layouts/team-03.png'
import img4 from '../images/layouts/team-04.png'

const dataTeam = [

    {
        id: 1,
        img: img1,
        name: 'Sneha Iyer',
        position: 'Founder & CEO'
    },
    {
        id: 2,
        img: img2,
        name: 'Kritika Singh',
        position: 'CO-Founder'
    },

    {
        id: 3,
        img: img3,
        name: 'Arjun Mehta',
        position: 'Chief Financial Officer'
    },

    {
        id: 4,
        img: img4,
        name: 'Vikram Desai',
        position: 'Developer'
    },    

]

export default dataTeam;
